import { ChangeDetectorRef, Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControlComponent } from '../../abstract-control/abstract-control.component';
import { FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { Moment } from 'moment/moment';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { ValidationErrorModule } from '@shared/component';
import { DateAdapter } from '@angular/material/core';
import { ZonedDateAdapter } from '@shared/adapters/zoned-date.adapter';
import { DateTime } from 'luxon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  imports: [
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    ValidationErrorModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltip
  ],
  // @TODO we might want to use it only for financial data, then it will be moved to ZonedDatepickerComponent
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [{ provide: DateAdapter, useClass: ZonedDateAdapter }]
})
export class DatepickerComponent extends AbstractControlComponent<Date> {

  @Input() placeholder = 'DD/MM/YYYY';
  @Input() max: Date;
  @Input() min: Date;
  @Input() endOfDay: boolean | string = false;
  @Input() startOfDay: boolean | string = false;
  @Input() dateFilter: (date: Moment) => boolean;
  @Input() tooltip: string;

  /**
   * the easiest way to fix day change issue for backend date fields without time
   * auto transform to utc time change date and saved without time in mysql
   */
  onDateChange(dateTime?: DateTime): void {
    let date: Date;

    if (dateTime) {
      // helps to avoid problems with -1day when db doesn't store time, but we should use DateTransformer in core instead
      dateTime = dateTime.set({ hour: 12 });
      if (this.endOfDay !== false) {
        dateTime = dateTime.endOf('day');
      }
      if (this.startOfDay !== false) {
        dateTime = dateTime.startOf('day');
      }
      date = dateTime.toJSDate();
    }

    this.onChange(date);
    this.onTouched();
  }
}
